export enum APP_TYPE {
  NONE,
  IMAGE,
}

export enum LANGUAGE {
  HK = "hk",
  EN = "en",
}

export enum SYSTEM_MESSAGE_TYPE {
  SYSTEM = "system",
  CONTRACT = "contract",
  FILE_REF = "file-ref",
  FILE = "file",
  TEXT = "text",
  IMAGE = "image",
}

export enum UNREAD_MESSAGE_TYPE {
  JUST_CONTRACT = "contract",
  JUST_CHAT = "chat",
}

export enum ASSET_TYPE {
  FILE_REF = "file-ref",
  FILE = "file",
  LINK_TEXT = "link-text",
  TEXT = "text",
  IMAGE = "image",
  CHATGPT_TEXT_QUESTION = "chatgpt-question",
  CHATGPT_TEXT_REPLY = "chatgpt-reply",
  CHATGPT_TEXT = "chatgpt",
  CHATGPT_IG = "chatgpt-ig",
  CHATGPT_IMAGE = "chatgpt-image",
  KOLA_QUESTION = "assistant-question",
  KOLA_RESPONSE = "assistant-response",
  CLEAR_UP = "clear-up",
  KOLA_KOLS_RECOMMENDATION = "kols-recommendation",
  KOLA_PRE_KOLS_RECOMMENDATION = "pre-kols-recommendation",
  KOLA_ERROR = "kols-error",
}

export enum ADMIN_REQUEST_TYPE {
  APPEAL = "APPEAL",
  BANK_CHECKOUT = "BANK_CHECKOUT",
  RECOMMEND_REQUEST = "RECOMMEND_REQUEST",
  PAYOUT_REQUEST = "PAYOUT_REQUEST",
  PAY_LATER_REQUEST = "PAY_LATER_REQUEST",
  KOL_REFERRAL_MISSION = "KOL_REFERRAL_MISSION",
}

export enum ADMIN_REQUEST_STATUS_TYPE {
  FINISHED,
  PENDING,
  REJECT,
}

export enum RECOMMEND_REQUEST_TYPE {
  PRODUCT,
  SERVICE,
  BRAND,
}

export enum RECOMMEND_REQUEST_GOAL_TYPE {
  REACH,
  CONVERSION,
  BRAND,
}

export enum CHATROOM_TYPE {
  JOB = "job",
  PRIVATE = "private",
  ADMIN = "admin",
  CHATGPT = "chatgpt",
  ASSISTANT = "assistant",
  DEFAULT = "",
}

export enum JOB_STATUS_TYPE {
  STATUS_0 = "status-0",
  STATUS_1 = "status-1",
  STATUS_2 = "status-2",
  STATUS_3 = "status-3",
  STATUS_4 = "status-4",
  STATUS_5 = "status-5",

  //suspend job
  STATUS_99 = "status-99",
}

export enum CHATROOM_PAGE_TYPE {
  LIST_CHAT = "list-chat",
  CHAT_TEXT = "chat",
  CONTRACT = "contract",
  FILE = "file",
  PROFILE = "profile",
}

export enum ROLE {
  KOL = "kol",
  CUSTOMER = "customer",
  ADMIN = "admin",
  DEFAULT = "",
}

export enum COMPONENT_DISPLAY {
  LIST = "LIST",
  TABLE = "TABLE",
}
